import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { ProfileForm } from "@/features/dashboard/perfil/components/ProfileForm";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";

export const Route = createFileRoute("/_private/dashboard/_base/perfil/")({
  component: RouteComponent
});

function RouteComponent() {
  return (
    <Stack>
      <DashboardComponents.Title>Editar Perfil</DashboardComponents.Title>

      <ProfileForm />
    </Stack>
  );
}
